module.exports = __webpack_public_path__ + "images/stickers/smile.072cbd8037a71978a723.png";